import cn from 'classnames';
import React, { type ReactNode } from 'react';
import { Text } from 'src/components/text/Text';

import styles from './Button.css';

interface Props {
  onClick: () => void;
  children: ReactNode;
  className?: string;
  testAttr?: string;
}

export const Button = ({ className, children, onClick, testAttr }: Props) => {
  return (
    <button
      type="button"
      className={cn(styles.Button, className)}
      onClick={onClick}
      data-test={testAttr}
    >
      <Text as="span" variant="body1TightBold">
        {children}
      </Text>
    </button>
  );
};
